import React from 'react';

const TableRow = props => {
  return <tr className="c-table__row">{props.children}</tr>;
};

export default TableRow;
